import React, { useEffect, useCallback, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  formatFilename,
  mapServiceTypes,
  formatMoney,
  mapBenefitResetPeriods,
  mapDiscountPeriods,
  formatDate,
} from '../../../utils';
import { Header, Title, Table, TableRow, TableCell } from '../../../components';
import { actions } from '../../../state';
import { config } from '../../../api/config';

const PAGE_SIZE = config.DEFAULTS.recordsPerPage;

const BusinessClientDiscounts = ({
  dispatch,
  memberships: { memberships, total, loading },
}) => {
  const [page, setPage] = useState(1);
  const pageCount = Math.ceil(total / PAGE_SIZE) || 1;
  const fetchMemberships = useCallback(
    data => {
      dispatch(actions.memberships.getMembershipsAction(data));
    },
    [dispatch]
  );

  const clearMemberships = useCallback(() => {
    dispatch(actions.memberships.clearMembershipsAction());
  }, [dispatch]);

  useEffect(() => () => clearMemberships(), [clearMemberships]);

  useEffect(() => {
    const offset = (page - 1) * PAGE_SIZE;
    fetchMemberships({ offset });
  }, [fetchMemberships, clearMemberships, page]);

  useEffect(() => {
    if (page > pageCount) {
      setPage(1);
    }
  }, [page, pageCount]);

  const xlsExport = () => {
    const filename = formatFilename(config.PAGES.discounts);
    dispatch(actions.discounts.exportDiscountsAsyncAction(undefined, filename));
  };

  const tableHeader = [
    'Nuolaidos planas',
    'Nuolaidos',
    'Priskirtų licencijų',
    'Nepriskirtų licencijų',
    'Tipas ',
    'Kaina/lic',
    'Kaina (bendra)',
    'Pradžios data',
    'Pabaigos data',
  ];

  const renderTable = () => {
    const getDiscountsInfo = benefits => {
      return benefits.map(benefit => (
        <div key={benefit.id}>
          {`${benefit.amount}${
            !benefit.reset_period
              ? '%'
              : ` (${mapBenefitResetPeriods(benefit.reset_period)})`
          } ${mapServiceTypes(benefit.service_type)}`}
        </div>
      ));
    };
    return memberships.map(membership => {
      const {
        id,
        title_lt,
        assigned_license_count,
        license_count,
        period,
        price,
        total_price,
        benefits,
        valid_from,
        valid_until,
      } = membership;
      return (
        <TableRow
          url={config.APP_PATHS.baDiscountPlan(id)}
          state={JSON.stringify(membership)}
          key={id}
        >
          <TableCell>{title_lt}</TableCell>
          <TableCell>{getDiscountsInfo(benefits)}</TableCell>
          <TableCell>{assigned_license_count ?? 0}</TableCell>
          <TableCell>{license_count - assigned_license_count ?? 0}</TableCell>
          <TableCell>{mapDiscountPeriods(period)}</TableCell>
          <TableCell>{formatMoney(price)}</TableCell>
          <TableCell>{formatMoney(total_price)}</TableCell>
          <TableCell>{valid_from ? formatDate(valid_from) : '-'}</TableCell>
          <TableCell>{valid_until ? formatDate(valid_until) : '-'}</TableCell>
        </TableRow>
      );
    });
  };

  return (
    <section>
      <Header>
        <Title total="">{config.PAGES.baDiscountPlans}</Title>
      </Header>

      <Table
        header={tableHeader}
        isEmpty={!memberships.length}
        loading={loading}
        page={page}
        pageSize={PAGE_SIZE}
        total={total}
        serverPagination={true}
        onPageChange={setPage}
      >
        {renderTable()}
      </Table>
    </section>
  );
};

const mapStateToProps = state => ({
  memberships: state.memberships,
  xlsLoading: state.download.xlsLoading,
});

BusinessClientDiscounts.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(BusinessClientDiscounts);
